import React from "react";
import { Link } from "react-router-dom";

const locations = [
  { name: "California", code: "CA" },
  { name: "Florida", code: "FL" },
  { name: "New Jersey", code: "NJ" },
  { name: "Georgia", code: "GA" },
  { name: "Nevada", code: "NV" },
  { name: "Illinois", code: "IL" },
  { name: "Maryland", code: "MD" },
  { name: "New York", code: "NY" },
  { name: "Texas", code: "TX" },
  { name: "Arizona", code: "AZ" },
];

const LocationsGrid = ({ currentCode }) => {
  // Filter out the current state
  const otherLocations = locations.filter(state => state.code !== currentCode);

  return (
    <div style={{ padding: "60px 0", background: "#f8fdf8", borderTop: "1px solid #e8f5e9" }}>
      <div className="container">
        <h2 style={{ textAlign: "center", fontSize: "1.8rem", fontWeight: 700, color: "#1a1a2e", marginBottom: "10px" }}>
          Care-Exchange Services Across the USA
        </h2>
        <p style={{ textAlign: "center", color: "#666", fontSize: "1rem", marginBottom: "36px" }}>
          Find trusted care seekers in your state
        </p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: "16px" }}>
          {otherLocations.map(state => (
            <Link
              key={state.code}
              to={`/find-care/${state.code}`}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "16px 18px",
                background: "#fff",
                border: "1px solid #e0f0e0",
                borderRadius: "12px",
                textDecoration: "none",
                color: "#1a1a2e",
                fontWeight: 600,
                fontSize: "0.92rem",
                boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
                transition: "all 0.2s ease",
              }}
              onMouseEnter={e => {
                e.currentTarget.style.background = "#45B14A";
                e.currentTarget.style.color = "#fff";
                e.currentTarget.style.borderColor = "#45B14A";
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow = "0 8px 20px rgba(69,177,74,0.25)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.background = "#fff";
                e.currentTarget.style.color = "#1a1a2e";
                e.currentTarget.style.borderColor = "#e0f0e0";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.04)";
              }}
            >
              <span style={{ fontSize: "1.1rem" }}>📍</span>
              <span style={{ flex: 1 }}>{state.name}</span>
              <span style={{ opacity: 0.5 }}>→</span>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LocationsGrid;
